import React from 'react';
import { Button, cn } from '@strivelabs/ui-core';
import { MessageCircle } from 'lucide-react';

export interface ChatCTABlockProps {
  context: string;
  buttonText?: string;
  onChatClick: () => void;
  className?: string;
}

export const ChatCTABlock: React.FC<ChatCTABlockProps> = ({
  context,
  buttonText = 'Chat Now',
  onChatClick,
  className,
}) => {
  return (
    <div className={cn('rounded-xl border-[0.5px] border-custom overflow-hidden', className)}>
      <div className="relative min-h-[43px] px-4 py-3 flex items-center justify-between gap-3 overflow-hidden before:absolute before:inset-0 before:bg-gradient-action before:opacity-[0.05] before:z-0">
        <p className="relative z-10 text-sm text-gray-700">
          {context}
        </p>
        <Button
          onClick={onChatClick}
          variant="gradient"
          className="relative z-10 shrink-0 h-[32px] px-5 whitespace-nowrap text-xs shadow-sm hover:shadow-md transition-shadow border border-red-200 text-orange-800"
        >
          <MessageCircle className="mr-1.5 h-3.5 w-3.5" />
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
